/* eslint-disable */
/** 
 * This file contains language specific message functions for tree-shaking. 
 * 
 *! WARNING: Only import messages from this file if you want to manually
 *! optimize your bundle. Else, import from the `messages.js` file. 
 * 
 * Your bundler will (in the future) automatically replace the index function 
 * with a language specific message function in the build step. 
 */


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const meta_title = () => `Amvera`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_apply = () => `Применить`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_cancel = () => `Отменить`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_delete = () => `Удалить`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_add = () => `Добавить`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_save = () => `Сохранить`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_download = () => `Скачать`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_send = () => `Отправить`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_close = () => `Закрыть`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_change = () => `Изменить`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_build = () => `Собрать`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const btn_save_and_rerun = () => `Сохранить и перезапустить`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const select_default = () => `Не выбрано`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const datepicker_pick_date = () => `Выберите дату`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const datepicker_pick_date_range = () => `Выберите период`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const datepicker_min = () => `Минуты`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const datepicker_hours = () => `Часы`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const form_date_picker_from = () => `От`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const form_date_picker_to = () => `До`


/**
 * @param {{ N: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const form_date_picker_last_N_minutes = (params) => `Последние ${params.N} минут`


/**
 * @param {{ N: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const form_date_picker_last_N_hours = (params) => `Последний ${params.N} час`


/**
 * @param {{ N: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const form_date_picker_last_N_hours_plural = (params) => `Последние ${params.N} часов`


/**
 * @param {{ N: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const form_date_picker_last_N_hours_plural_2 = (params) => `Последние ${params.N} часа`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const field_name = () => `Название`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const required_field = () => `Обязательное поле`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const no_spaces = () => `Без пробелов`


/**
 * @param {{ maxLength: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const max_length = (params) => `Максимальная длина ${params.maxLength} символов`


/**
 * @param {{ minLength: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const min_length = (params) => `Минимальная длина ${params.minLength} символов`


/**
 * @param {{ maxNumber: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const max_number = (params) => `Максимальное значение ${params.maxNumber}`


/**
 * @param {{ minNumber: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const min_number = (params) => `Минимальное значение ${params.minNumber}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const data_table_pagination_rpp = () => `Строк на страницу`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const data_table_pagination_page = () => `Страница`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const data_table_noResults = () => `Нет результатов.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const header_user_exit = () => `Выход`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const header_balance = () => `Баланс`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const header_lang = () => `Язык:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const api_error_somethingWentWrong = () => `Что-то пошло не так`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const api_success = () => `Успешно изменено`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const field_error_required = () => `Обязательное поле`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const confirm_dialog_title = () => `Подтверждение`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const confirm_dialog_yes = () => `Да`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const confirm_dialog_no = () => `Нет`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_null = () => `Проект не развертывался`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_null_hint = () => `Для запуска приложения загрузите данные и соберите проект`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_CREATING = () => `Проект создается`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_CREATING_hint = () => `Если проект находится в статусе создания более минуты, произошла ошибка создания, пересоздайте проект`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_EMPTY = () => `Проект не развертывался`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_EMPTY_hint = () => `Для запуска приложения загрузите данные и соберите проект`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_BUILD_STARTED = () => `Выполняется сборка`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_BUILD_STARTED_hint = () => `Ознакомиться с процессом сборки можно во вкладке "Лог сборки"`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_BUILD_STOPPED = () => `Сборка остановлена`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_BUILD_FAILED = () => `Ошибка сборки. Смотри лог сборки`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_BUILD_FAILED_hint = () => `Ознакомиться с ошибками сборки можно во вкладке "Лог сборки". Проверьте правильность конфигурации и/или Dockerfile`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_DEPLOYING = () => `Проект развертывается`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_DEPLOYING_hint = () => `Сборка выполнена успешно, выполняется развертывание`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_DEPLOY_FAILED = () => `Ошибка развертывания. Смотри лог приложения`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_DEPLOY_FAILED_hint = () => `Развертывание завершилось с ошибкой. Проверьте правильность amvera.yaml/Dockerfile. При повторении ошибки обратитесь в службу поддержки`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_STARTING = () => `Выполняется запуск`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_STARTING_hint = () => `Успешно развернуто, выполняется запуск`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_RUN_ERROR = () => `Приложение запускается или работает c ошибкой. Смотри лог приложения`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_RUN_PROBLEM = () => `Работает с ошибкой. Смотри лог приложения`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_RUN_PROBLEM_hint = () => `Контейнеры приложения не могут запуститься из-за ошибки`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_RUN_ERROR_hint = () => `Приложение ещё не успело запуститься или произошла ошибка в его работе. Ознакомьтесь с логом приложения и проверьте файл конфигурации`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_RUNNING = () => `Приложение запущено`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_RUNNING_hint = () => `Приложение работает без ошибок`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_STOPPED = () => `Приложение остановлено`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_STOPPED_hint = () => `Для возобновления работы проекта воспользуйтесь кнопкой запуска или задайте нужное количество инстансов`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_STOPPING = () => `Сервис останавливается`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_FROZEN = () => `Приложение заморожено`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_FROZEN_hint = () => `Проект был остановлен более 30 дней назад. Для запуска пересоберите и запустите проект`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_STOPPED_WITH_ERROR = () => `Остановлено из-за повторяющейся ошибки. Смотри лог сборки/приложения `


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_STOPPED_WITH_ERROR_hint = () => `Остановлено из-за повторяющейся ошибки. Ознакомьтесь с логом приложения для определения причин ошибки`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_SCALING = () => `Меняем количество реплик`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_SCALING_hint = () => `Меняем количество реплик`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_clusterHealthyState = () => `PostgreSQL запущен`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_settingUpPrimary = () => `PostgreSQL запускается`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_waitingForInstances = () => `PostgreSQL запускается`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_status_creatingNewReplica = () => `Идет создание новой реплики`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_title = () => `Загрузка файлов`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_commitMsg = () => `Commit message`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_commitMsg_placeholder = () => `Введите сообщение коммита`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_text = () => `Для загрузки перетащите папки или файлы в эту область`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_maxSize = () => `Максимальный размер:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_mb = () => `МБ`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_zip = () => `Загрузка Zip-архивов не поддерживается.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_uploadedFiles = () => `Загруженные файлы`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_noFiles = () => `Нет загруженных файлов.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_deleteAll = () => `Удалить все`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const upload_dialog_field_upload_success = () => `Загрузка файлов прошла успешно.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const projectCreation_firstProject = () => `Создайте первый проект!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const projectCreation_firstDb = () => `Создать базу данных`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const projectCreation_firstProject_title = () => `Проектов пока нет`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const projectCreation_firstProject_free = () => `Создание проекта бесплатно.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const projectCreation_firstProject_free_desc = () => `Списания производятся только за работающие контейнеры в статусах «Приложение запущено» или «Приложение работает с ошибкой»`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_sidebar_title = () => `Проекты`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_sidebar_apps = () => `Приложения`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_sidebar_postgres = () => `PostgreSQL`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_sidebar_preconfigured = () => `Предустановленные сервисы`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_sidebar_docs = () => `Документация Amvera`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_info = () => `Инфо`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_repo = () => `Репозиторий`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_dir = () => `Хранилище`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_config = () => `Конфигурация`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_logs = () => `Логи`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_envvars = () => `Переменные`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_domains = () => `Домены`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_backups = () => `Бэкапы`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_alerts = () => `Мониторинг`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_settings = () => `Управление`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_logDb = () => `Логи БД`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_details = () => `Детализация`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_balance = () => `Пополнение баланса`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const secondary_sidebar_legal = () => `Юридическим лицам`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_main = () => `Главная`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_projects = () => `Проекты`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_applications = () => `Приложения`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_dbs = () => `PostgreSQL`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_balance = () => `Баланс`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumbs_preConfig = () => `Преднастроенные сервисы`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_title = () => `Создание проекта`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service = () => `Выбор сервиса`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff = () => `Тариф`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_upload = () => `Загрузка данных`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_config = () => `Конфигурация`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_variables = () => `Переменные`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_next_btn = () => `Далее`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_back_btn = () => `Назад`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_fin_btn = () => `Завершить`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_gitDialog_desc = () => `Прежде чем завершить создание вы можете задать и скачать конфигурационный файл. После этого положите его в корень проекта, выполните команду git push, и сборка начнется автоматически.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_gitDialog_confirm = () => `Завершить создание`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_serviceType = () => `Тип сервиса`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_serviceType_placeholder = () => `Выберите тип сервиса`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_projectType = () => `Задайте параметры сервиса`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_projectType_placeholder = () => `Выберите тип проекта`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketType = () => `Задайте тип сервиса`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketType_placeholder = () => `Выберите тип сервиса`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_serviceTypes_app = () => `Приложение`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_serviceTypes_db = () => `База данных (managed)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_serviceTypes_marketplace = () => `Преднастроенное приложение из маркетплейса`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketPlaceLables_mq = () => `Брокеры очередей`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketPlaceLables_db = () => `Базы данных`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketPlaceLables_authorization = () => `Авторизация`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketPlaceLables_bi = () => `Бизнес Аналитика`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketPlaceLables_db_utils = () => `Утилиты для баз данных`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketPlaceLables_db_mail_and_notifications = () => `Почта и уведомления`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_service_marketPlaceLables_ai = () => `Машинное обучение и искусственный интеллект`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_projectName = () => `Название проекта`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_projectName_placeholder = () => `Введите название проекта`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_projectName_symbolErrors = () => `Имя проекта может содержать маленькие и заглавные буквы, цифры и знаки дефиса`


/**
 * @param {{ maxLength: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_projectName_lengthError = (params) => `Максимальная длина ${params.maxLength} символов`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_projectName_noNew = () => `Слов "new" нельзя использовать.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_plan_alert = () => `Рекомендуем при первом запуске использовать один из старших тарифов. После успешного запуска вы сможете снизить тариф.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_tariff_plan = () => `Выберите тариф`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_upload_gitOption = () => `Через git`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_upload_gitOption_hint = () => `Вы можете пропустить шаги, создав пустой проект и загрузить файлы и конфигурацию позже.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_upload_interfaceOption = () => `Через интерфейс`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_upload_interfaceOption_hint_start = () => `Если проект на python, не забудьте файл с зависимостями requirements.txt `


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_upload_interfaceOption_hint_link = () => `(инструкция по созданию)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_upload_interfaceOption_hint_end = () => `, и не загружайте папку venv`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_config_alert = () => `Задание конфигурации создает коммит в репозиторий. Для привязки к имеющимся репозиториям необходимо будет сделать merge.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_config_title = () => `Конфигурационный файл`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_config_downloadConfig = () => `Скачать конфигурацию`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_error_409 = () => `Проект с таким названием уже существует`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const create_dialog_step_error_500 = () => `Ошибка сервера`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_title = () => `Проекты`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_card_app = () => `Приложения`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_card_db = () => `PostgreSQL`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_card_preconfigured = () => `Преднастроенные сервисы`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_card_total = () => `Всего`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_card_running = () => `Запущено`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_card_clutster = () => `Кластер`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_createBtn = () => `Создать проект`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const main_page_services = () => `Создать преднастроенный сервис`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const db_main_page_title = () => `Базы данных PostgreSQL`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const db_main_page_table_column_name = () => `Название`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const db_main_page_table_column_type = () => `Тип`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const db_main_page_table_filter = () => `Тип БД`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const app_main_page_btn = () => `Создать приложение`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const preConfig_main_page_title = () => `Преднастроенные сервисы`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const preConfig_main_page_btn = () => `Создать преднастроенный сервис`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const resource_status_NONE = () => `Неактивный`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const resource_status_NO_DATA = () => `Расчет потребления`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const resource_status_RED = () => `Потребление выше 85%`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const resource_status_YELLOW = () => `Высокое потребление`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const resource_status_GREEN = () => `Потребление в норме`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_replicas = () => `Реплик`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_replicas_tooltip_cur = () => `Текущее кол-во инстансов`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_replicas_tooltip_req = () => `Требуемое кол-во инстансов`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_start = () => `Включить`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_stop = () => `Выключить`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_rebuild = () => `Пересобрать`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_rerun = () => `Перезапустить`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const project_ctrl_btns_project = () => `проект`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_title = () => `Пополнение баланса`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_topup = () => `Сумма пополнения`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_limit = () => `Ограничение автоплатежей в месяц`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_limit_tooltip = () => `Автоплатеж производится только при снижении баланса <100 руб. Задайте максимальное количество автоплатежей в месяц`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_autoPay = () => `Подключить автоплатеж`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_addFunds = () => `Пополнить`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_promoCode = () => `Промокод`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_usedPromocodes = () => `Использованные промокоды:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_promoCode_placeholder = () => `Введите код`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_promo_200 = () => `Промокод успешно добавлен`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_promo_404 = () => `Недействительный промокод`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_promo_406 = () => `Срок действия промокода истек`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_promo_409 = () => `Промокод уже использован`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_promo_500 = () => `Ошибка сервера, повторите, пожалуйста, попытку позже`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_promo_501 = () => `Промокод еще не реализован`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_recurrent_delete_success_snack = () => `Автоплатеж удален.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_recurrent_amount = () => `Подключенный автоплатеж:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_recurrent_max_amount = () => `Максимальное число платежей в месяц:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_details_req = () => `Сведения и реквизиты`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_closingDocs = () => `Закрывающие документы`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice = () => `Создать счёт`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_shortName = () => `Краткое название юридического лица *`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_fullName = () => `Полное название юридического лица`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_tin = () => `ИНН *`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_kpp = () => `КПП`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_ogrn = () => `ОГРН`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_beneficiaryAccount = () => `Счет`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_bic = () => `БИК банка`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_additionalMail = () => `Дополнительная почта для связи`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_additionalMail_emailError = () => `Введите корректный e-mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_additionalPhoneNumber = () => `Дополнительный телефон для связи`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_additionalPhoneNumber_numberError = () => `Введите корректный номер телефона`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_field_amount_error = () => `Введите сумму`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_closingDocs_docType = () => `Тип документа`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_closingDocs_docType_BILL = () => `Счет`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_closingDocs_docType_INVOICE = () => `Инвойс`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_closingDocs_docType_RECONCILIATION_REPORT = () => `Акт сверки`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_closingDocs_date = () => `Дата создания`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_closingDocs_time = () => `Период`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_warn = () => `Перевод может занять от 3 до 5 рабочих дней`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_btn_issue = () => `Выписать счёт`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_table_date = () => `Дата счета`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_table_status = () => `Статус`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_table_amount = () => `К оплате`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_table_sendEmail = () => `Отправить по почте`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_sendEmail_200 = () => `Письмо отправлено!`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_emailTitle = () => `Отправить на почту`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_emailInfo = () => `Счет будет отправлен на электронный адрес, указанный при регистрации:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_legal_invoice_orDiffEmail = () => `Или введите другой:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_history = () => `Детализация баланса`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_writeOffs = () => `Списания`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_credits = () => `Зачисления`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_serviceType = () => `Тип сервиса`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_service = () => `Сервис`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_plan = () => `Тариф`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_productName = () => `Тип ресурса`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_units = () => `Кол-во ед.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_price = () => `Цена за ед.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_amount = () => `Стоимость`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_from = () => `От`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_to = () => `До`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_amount2 = () => `Сумма`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_paymentType = () => `Тип оплаты`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_currency = () => `Валюта`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_date = () => `Дата`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_manual = () => `Платеж`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const billing_tab_balance_autoPayment = () => `Автоплатеж`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_examplesHelper = () => `Примеры развертывания`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_herokuHelper = () => `Миграция с Heroku`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_configHeader = () => `Конфигурационный файл`


/**
 * @param {{ docDomain: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_configDescription = (params) => `Для запуска проекта необходим конфигурационный файл <a target='_blank' rel='noopener noreferrer' className='text-link underline' href='${params.docDomain}/applications/configuration/config-file.html'>amvera.yml</a>, который можно написать вручную, сгенерировать через <a target='_blank' rel='noopener noreferrer' className='text-link underline' href='https://manifest.amvera.ru'>специальный сервис</a> или задать в разделе Конфигурация. Также поддерживается использование <a target='_blank' rel='noopener noreferrer' className='text-link underline' href='${params.docDomain}/applications/configuration/docker.html'>Dockerfile</a>.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_deployHeader = () => `Развертывание проекта`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_deployDescription = () => `Проект использует для хранения кода Git-репозиторий, содержимое и данные для доступа в который доступны в разделе &laquo;Репозиторий&raquo;.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_deployOptionsHeader = () => `Три основных способа разворачивания проекта`


/**
 * @param {{ docDomain: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_deployOptionsLi1 = (params) => `Через push в Git-репозиторий с конфигурационным файлом. Необходимо склонировать или привязать репозиторий проекта, добавить <a target='_blank' rel='noopener noreferrer' className='text-link underline' href='${params.docDomain}/applications/configuration/config-file.html'>файл конфигурации</a> в его корень и сделать git push. Сборка проекта начнется автоматически.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_deploymentOptionsLi2 = () => `Через push в Git-репозиторий и конфигурацией в интерфейсе. В разделе &quot;Конфигурация&quot; указать необходимые параметры и нажать &quot;Применить&quot;, склонировать себе репозиторий, который теперь будет содержать конфигурационный файл, перенести необходимый код в этот репозиторий и сделать push. Сборка проекта начнется автоматически.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_deploymentOptionsLi3 = () => `Воспользоваться загрузчиком на странице &quot;Репозиторий&quot;. Когда все данные будут загружены, заполнить раздел Конфигурация (если не загрузили конфигурационный файл) и нажать кнопки &quot;Применить&quot; и &quot;Собрать&quot;.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_domainHeader = () => `Домены и внутренние имена`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_domainDescription = () => `Подключить бесплатное, или привязать свое доменное имя можно в разделе &quot;Домены&quot;.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_domainOptionsLi1 = () => `Внутреннее доменное имя:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_domainOptionsLi1_caption = () => `можно обратиться из другого проекта, должно слушать порт 80`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_domainOptionsLi2 = () => `Папка постоянного хранилища:`


/**
 * @param {{ serviceType: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_marketplace_title = (params) => `${params.serviceType} — преднастроенный сервис из маркетплейса`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_marketplace_description = () => `Представляет собой приложение с заданными настройками и переменными.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tabs_info_marketplace_externalDomain = () => `Внешний домен вы можете создать в разделе "Домены".`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbInfo_connectHelper = () => `Подключение к БД`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbInfo_pgAdmin = () => `Деплой pgAdmin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbInfo_domainTitle = () => `Для доступа к базе данных из других проектов Амвера достаточно указать одно из трех доменных имен:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbInfo_domainRwOption = () => `для чтения/записи:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbInfo_domainRoOption = () => `только для чтения в режиме hot standby:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbInfo_domainROption = () => `для чтения с произвольной из развернутых нод:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_version_hint = () => `Версия PostgreSQL`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbName = () => `Имя создаваемой БД`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbName_placeholder = () => `Введите имя БД`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbName_hint = () => `Имя для базы данный, которая будет создана в кластере.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbUsername = () => `Имя пользователя`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbUsername_placeholder = () => `Введите имя пользователя`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbUsername_hint = () => `Имя для пользователя, под которым будет реализовываться вход в СУБД.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbPassword = () => `Пароль пользователя`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbPassword_placeholder = () => `Введите пароль пользователя`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_dbPassword_hint = () => `Пароль для указанного выше пользователя, под которым будет реализовываться вход в СУБД.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_instances = () => `Размер кластера СУБД`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_instances_placeholder = () => `Введите количество реплик для СУБД`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_instances_hint = () => `Количество реплик СУБД. При этом одна из реплик будет мастером и в связи с особенностями СУБД доступ на запись будет доступен только через неё.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_superuser = () => `Активировать Superuser Access`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_superuser_hint = () => `Активировать доступ суперпользователя с именем пользователя`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_superuserPassword = () => `Пароль для Superuser`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_superuserPassword_placeholder = () => `Введите пароль суперпользователя`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbConfig_superuserPassword_hint = () => `Пароль для пользователя <code>postgres</code>, под которым возможен вход в СУБД с правами суперпользователя.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_alert_backups = () => `Бэкапы`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_alert_restoreBackups = () => `Восстановление бэкапов`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_activateDaily = () => `Активировать ежедневные бэкапы`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_instant = () => `Моментальные бэкапы`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_empty = () => `На данный момент нет бэкапов.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_create = () => `Создать бэкап`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_dialog_tilte = () => `Укажите описание бэкапа:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_dialog_create_success = () => `Бэкап успешно создан`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_dialog_restore_errorName = () => `Имя сервиса может содержать маленькие и заглавные буквы, цифры и знаки дефиса.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_dbBackups_dialog_restore_maxLengthErorr = () => `Максимальная длина описания 300 символов`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_upload_btn = () => `Загрузить данные`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_download_btn = () => `Скачать данные`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_download_selection = () => `Выберите, что требуется скачать:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_download_storage = () => `Постоянное хранилище`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_download_code = () => `Код`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_download_artifacts = () => `Артефакты`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_download_repo = () => `Репозиторий`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_folder = () => `Выберите папку:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_folder_empty = () => `Пустая папка`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_folder_init = () => `Загрузка файлов возможна только после первого запуска приложения`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitTitle_v2 = () => `Подключить GitHub, GitLab, Bitbucket`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitTitle = () => `Подключить GitHub, GitLab, Bitbucket (ручная настройка)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_event = () => `Ивент:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_event_hint = () => `Необходимо выбрать один вариант`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_url_hint = () => `Ссылка, которую нужно вставить в настройках webhook.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_secret = () => `Секрет:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_secret_error = () => `Обязательный параметр. По нему осуществляется валидация запроса.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_token = () => `Токен:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_remoteRepo = () => `Удаленный репозиторий:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_remoteBranch = () => `Ветка удаленного репозитория:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_remoteBranch_hint = () => `Можно использовать только строчные, заглавные латинские буквы, цифры и спец символы: <code>_</code>, <code>-</code>, <code>/</code> и <code>.</code>`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connect_btn = () => `Подключить`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connect_first_success = () => `Репозиторий подключен.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connect_change_success = () => `Репозиторий изменен.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connect_copied = () => `Скопировано в буфер.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connection_title = () => `Или использовать выделенный репозиторий Amvera`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connection_primary = () => `Использовать как основной репозиторий:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connection_or = () => `или`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connection_existing = () => `Подключить к существующему репозиторию:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connection_submit = () => `Отправить изменения:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_connection_ifPrimary = () => `Если используется как основной репозиторий:`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_helper = () => `Способы разрешения возможных ошибок`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_helper_data = () => `Обязательно сохраняйте SQLite и подобные файлы в постоянное хранилище /data. Правильный путь в коде /data/имя_файла.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_delete_git_confirm = () => `Вы действительно хотите удалить?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_remoteRepo_placeholder = () => `Выберите удаленный репозиторий`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_remoteBranch_placeholder = () => `Выберите ветку`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_remoteBranch_error = () => `Необходимо выбрать ветку удаленного репозитория`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_fetchBranch_error = () => `Не удалось получить ветки удаленного репозитория`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_post_success = () => `Вебхук успешно добавлен`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_edit_success = () => `Вебхук успешно обновлен`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_delete_success = () => `Вебхук успешно удален`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_delete_error = () => `Не удалось удалить вебхук`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_repo_gitWebhook_v2_existing_error_hint = () => `Вебхук уже привязан, необходимо удалить, перед тем как создать новый`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_field_environment_label = () => `Выберите окружение`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_field_toolchain_label = () => `Выберите инструмент`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_field_version_label = () => `Выберите версию`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_field_change_success = () => `Конфигурация успешно изменена`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_mainFileName_error_wrongName = () => `В коде не найден указанный файл, измените название или проверьте путь`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_mainFileName_error_wrongPath = () => `Путь до запускаемого файла не совпадает с путем в коде`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_python_requirementsPath_error_noFile = () => `В загруженных файлах не найден requirements.txt, либо он имеет другое название. Загрузите файл с зависимостями или приведите имя в соответствие со значением в конфигурации`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_python_requirementsPath_error_wrongName = () => `В коде не найден указанный файл, измените название или проверьте путь. <a target='_blank' rel='noopener noreferrer' className='text-status-info link' href='https://docs.amvera.ru/applications/environments/python-pip.html#requirements-txt'>Инструкция по созданию</a> requirements.txt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_python_requirementsPath_error_wrongPath = () => `Путь до requirements.txt в коде и конфигурации не совпадает`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_build_log = () => `Лог сборки`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_run_log = () => `Лог приложения`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_db_log = () => `Лог БД`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_system_log = () => `Лог системы`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_alertTitle_default = () => `Загрузка лога занимает до 3 минут.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_alertTitle_build = () => `Смотрите лог Приложения (не сборки) если статус проекта  "Приложение запускается" или "Приложение Запущено". Загрузка лога занимает до 3 минут.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_alertTitle_run = () => `Смотрите лог Сборки (не приложения) если статус проекта  "Выполняется сборка". Загрузка лога занимает до 3 минут.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_alert_errors = () => `Частые ошибки`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_loading = () => `Идет загрузка истории...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_download_hint = () => `Для загрузки логов нажмите на кнопку "Выполнить запрос" или включите "Режим стрима"`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_load_logs = () => `Выполнить запрос`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_query = () => `Поиск по логу`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_limit = () => `Количество записей`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_show_date = () => `Показывать время`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_tail_mode = () => `Режим стрима`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_logs_no_logs = () => `Лога пока нет, повторите запрос через минуту.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_title = () => `Переменные окружения`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_noVars = () => `Переменных окружения пока нет`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_alert_desc = () => `Для применения изменений необходимо перезапустить контейнеры`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_secret_btn = () => `Создать секрет`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_secret_title = () => `Создание секрета`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_secret_description = () => `Секреты доступны только в контейнерах этого проекта и недоступны для просмотра после создания`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_field_value = () => `Значение`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_var_btn = () => `Создать переменную`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_var_title = () => `Создание переменной`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_var_description = () => `Переменные окружения доступны только в контейнерах этого проекта`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_var_name_error_quotes = () => `Имя не может содержать кавычки`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_var_value_error_quotes = () => `Значение не может содержать кавычки`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_table_column_name = () => `Название`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_table_column_value = () => `Значение`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_table_column_secret = () => `Это секрет`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_table_actions = () => `Действия`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_table_action_changeVar = () => `Изменить переменную`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_changeVar_title = () => `Редактирование переменной`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_changeVar_desc = () => `Переменные окружения доступны только в контейнерах этого проекта`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_changeSec_title = () => `Редактирование секрета`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_changeSec_desc = () => `Секреты доступны только в контейнерах этого проекта и недоступны для просмотра после создания`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_table_action_deleteVar = () => `Удалить переменную`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_delete_title = () => `Удаление переменной`


/**
 * @param {{ name: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_envvars_dialog_delete_desc = (params) => `Вы действительно хотите удалить переменную ${params.name}?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_page_title_im = () => `Доменные имена`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_column_action = () => `Действие`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_column_connectionType = () => `Тип подключения`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_column_type = () => `Тип`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_column_type_internal = () => `Внутренний`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_column_type_external = () => `Внешний`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_domainType_external = () => `Внешний домены`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_domainType_internal = () => `Внутренний домены`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_editDialog_title = () => `Дефолтное доменное имя`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_editDialog_desc_deactivate = () => `Деактивировать дефолтное доменное имя?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_editDialog_desc_activate = () => `Активировать дефолтное доменное имя?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_deleteDialog_title = () => `Удаление`


/**
 * @param {{ domainName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_deleteDialog_desc = (params) => `Удалить домен '${params.domainName}'?`


/**
 * @param {{ ingressType: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_editIngressType_success = (params) => `Тип подключения изменен на ${params.ingressType}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_editIngressType_title = () => `Изменение типа подключения`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_editIngressType_desc = () => `Вы можете поменять тип подключения для данного домена с HTTP на HTTPS и наоборот.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_add_btn = () => `Создать доменное имя`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_title = () => `Добавление доменного имени`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_field_connectionType = () => `Тип подключения`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_field_domainType = () => `Тип домена`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_field_your = () => `Свой домен`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_field_free = () => `Бесплатный домен Амвера`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_steps_title = () => `Для добавления домена Вам необходимо:`


/**
 * @param {{ externalIp: NonNullable<unknown>, ownerName: NonNullable<unknown>, slug: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_steps_1 = (params) => `Создать в DNS A запись: ${params.externalIp} и TXT запись: ${params.ownerName}-${params.slug}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_steps_2 = () => `Дождаться, пока обновления распространятся по DNS серверам`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_steps_3 = () => `Ввести доменное имя в поле ниже (без http или https)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_field_name = () => `Доменное имя`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_field_placeholder = () => `Необходимо выбрать тип подключения.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_field_name_placeholder = () => `Доменное имя (без http или https)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_title = () => `Дополнительные настройки`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_section_ports = () => `Порты`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_field_url_placeholder = () => `Введите URL путь`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_field_url_error = () => `Путь должен начинаться с /.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_field_url_req = () => `Укажите путь URL.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_field_port_placeholder = () => `Введите порт`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_field_port_req = () => `Укажите порт.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_additionalSettings_field_port_numberError = () => `Порт должен быть числом`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_addDialog_success = () => `Домен успешно добавлен`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_domains_ports_success = () => `Порты добавлены.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_title = () => `Бэкапы /data`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_helper = () => `Бэкапы`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_noAccess = () => `Бэкапы доступны для проектов с тарифным планом "Начальный плюс" и выше`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_noBackups = () => `На данный момент нет бэкапов.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_ready_hint_EMPTY = () => `Не найден. Бэкапы производятся только для постоянного хранилища /data. Убедитесь в использовании постоянного хранилища и попробуйте подготовить бэкап позднее.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_ready_hint_READY = () => `Подготовить заново`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_ready_hint_ERROR = () => `Ошибка. Попробуйте подготовить заново`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_ready_default = () => `Подготовить для скачивания`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_download = () => `Скачать бэкап`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_recovery_title = () => `Восстановление данных после инцидента 21 марта`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_recovery_alert = () => `Прежде чем запускать восстановление данных, перезапустите проект и подождите некоторое время.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_recovery_alert_409 = () => `Сначала перезапустите проект.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_recovery_button = () => `Восстановить данные`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_recovery_success_notification = () => `Запущено восстановление данных`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_backups_recovery_note = () => `Запуск восстановления данных заменит постоянное хранилище старыми данными.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff = () => `Тариф и управление`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_field_plan = () => `Тарифный план`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_alert = () => `После смены тарифного плана все контейнеры проекта будут перезапущены`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_field_plan_placeholder = () => `Выберите план`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_changed_success = () => `Тариф успешно изменен`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_managment = () => `Управление`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_freeze = () => `Заморозка`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_freeze_btn = () => `Заморозить проект`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_freeze_success = () => `Проект заморожен`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete = () => `Удаление`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete_project = () => `Удалить проект`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete_description = () => `Действия в этой секции необратимы!`


/**
 * @param {{ projectName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete_title = (params) => `Удалить проект ${params.projectName}?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete_dialog_description = () => `Удаление проекта остановит все работающие инстансы и <strong>удалит репозиторий с кодом</strong>. После того, как вы нажмете на кнопку "Удалить", никто — даже мы — <strong>не сможет восстановить данные</strong>. Если вы все еще хотите удалить проект, введите следующую строку в поле для ввода:`


/**
 * @param {{ projectName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete_dialog_confirmText = (params) => `удалить навсегда ${params.projectName}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete_dialog_field_placeholder = () => `Указать строку для удаления`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_tariff_delete_dialog_failed = () => `Произошла ошибка при удалении проекта`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_notifactions = () => `Уведомления`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_notif_autoscaling = () => `Автоскейлинг и уведомления`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts = () => `Алерты`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_interface = () => `Уведомления в интерфейсе`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard = () => `Метрики`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_success = () => `Настройки алертов применены`


/**
 * @param {{ errorMessage: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_error = (params) => `${params.errorMessage}: Что-то пошло не так`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_noAccess = () => `Алерты доступны для проектов с тарифным планом "Начальный плюс" и выше`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_field_projectFailures = () => `Оповещения при сбоях работы проекта`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_field_cpuUsage = () => `Если произошло повышение метрик CPU выше заданной величины (%) от тарифа`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_field_ramUsage = () => `Если произошло повышение метрик ОЗУ выше заданной величины (%) от тарифа`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_field_k8 = () => `Поддержка проб Kubernetes`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_field_buildFailed = () => `Ошибка сборки проекта`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_field_runFailed = () => `Ошибка запуска проекта`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_field_channel = () => `Выберите канал уведомления`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_field_channel_placeholder = () => `Выберите канал уведомления`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_field_channel_email = () => `Почта`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_field_channel_maxPerDay = () => `Укажите максимальное количество уведомлений в день`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_enabled_tg_bot_link = () => `Ссылка`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_enabled_tg_bot_link2 = () => `на телеграм-бота`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_disabled_tg_bot_link = () => `Уведомления подключены к телеграм-боту, изменить аккаунт можно по`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_disabled_tg_bot_link2 = () => `ссылке`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_enabled_tg_bot_link_hint = () => `Уведомления будут высылаться на подключенный в боте аккаунт`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_enabled_tg_bot_alert = () => `Требуется подключить уведомления в боте`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_enabled_tg_bot_qrAlt = () => `QR-код для подключения алертов через Telegram-бот`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_tg_alertValue = () => `Выберите значение для алерта`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_tg_alertValue_placeholder = () => `Выберите значение`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_yamlConfig = () => `Конфиг в yaml-формате`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_yamlConfig_placeholder = () => `Введите конфиг в yaml-формате`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_exit_dialog_title = () => `Применить изменения?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_exit_dialog_desc = () => `Все несохраненные изменения будут потеряны`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_alerts_settings_exit_dialog_closeWithoutSaving = () => `Закрыть без сохранения`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_interface_title = () => `Всплывающие в интерфейсе уведомления ошибок приложения`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_interface_changed_success = () => `Настройки оповещений успешно изменены`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_metric_ram_label = () => `Потребление ОЗУ`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_metric_cpu_label = () => `Потребление CPU`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_metric_cpu_throttling_label = () => `Троттлинг CPU`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_noAccess = () => `Метрики доступны для проектов с тарифным планом "Начальный плюс" и выше`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_chart_loading = () => `Загрузка данных...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_chart_error = () => `Произошла ошибка при загрузке данных`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_chart_noData = () => `Нет данных`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_chart_time = () => `Время`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_chart_usage = () => `Потребление`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_chart_throttling = () => `Длительность троттлинга`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_tab_dashboard_chart_seconds = () => `c`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_failure_title = () => `Оповещения при сбоях работы проекта`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_failure_field_maxPerDay = () => `Максимальное количество оповещений`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_failure_field_minUptime = () => `Минимальное время работы приложения`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_failure_hint = () => `Установите максимальное количество уведомлений в день и минимальное время работы приложения.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_error_popups_title = () => `Всплывающие уведомления ошибок приложения`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_autoscaling = () => `Автоскейлинг`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_autoscaling_description = () => `Если нагрузка на ресурсы достигает критического уровня (индикатор светофора красный), система инициирует повышение тарифа для обеспечения стабильной работы.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_alerts_autoscaling_changed_success = () => `Настройки успешно изменены`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_hash = () => `Хэш`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_commitDate = () => `Дата коммита`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_statusCode = () => `Статус сборки`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_stored = () => `Хранится`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_stored_hint = () => `Если архив сборки проекта хранится, откат для таких проектов происходит быстрее — без повторной сборки.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_protected = () => `Защищен от удаления`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_inUse = () => `Используется`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_runVersion = () => `Запустить эту версию`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_rebuildVersion = () => `Пересобрать эту версию`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_delete = () => `Удалить`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_delete_confirm = () => `Вы действительно хотите удалить?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_delete_archive = () => `Удалить архив`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_delete_archive_confirm = () => `Вы действительно хотите удалить архив?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_rollbackVersion = () => `Откатить эту версию`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_rollbackVersion_confirm = () => `Вы действительно хотите откатить версию?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_saveFromDel = () => `Защитить от удаления`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_saveFromDel_confirm = () => `Вы действительно хотите защитить от удаления?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_removeSaveFromDel = () => `Снять защиту от удаления`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_rollbacks_table_actions_removeSaveFromDel_confirm = () => `Вы действительно хотите снять защиту от удаления?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const snackbar_phrase_start = () => `В логе зафиксирована ошибка, решение которой описано по `


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const snackbar_phrase_link = () => `ссылке`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const snackbar_phrase_end = () => ` в документации.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer_socials_title = () => `Мы в соцсетях`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer_socials_vk = () => `ВК группа`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer_socials_telegram = () => `Телеграм канал`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer_socials_habr = () => `Хабр блог`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer_techsupport_title = () => `Техподдержка Amvera`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer_techsupport_timezone = () => `Отвечаем с 9:00 до 20:00 МСК`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer_support_tgChat = () => `Чат Комьюнити в Телеграм`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const repo_download_files_success = () => `Файлы успешно скачаны`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const repo_download_files_error = () => `Не удалось скачать файлы`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const persistent_snackbar_BUILD = () => `сборки`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const persistent_snackbar_RUN = () => `приложения`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const persistent_snackbar_RELEASE = () => `релиза`


/**
 * @param {{ stage: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const persistent_snackbar_msgTitle = (params) => `Лог ${params.stage} требует внимания.`


/**
 * Failed to resolve message field_description for languageTag "ru". 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const field_description = () => "field_description"


/**
 * Failed to resolve message tab_config_python_scriptName_error_wrongName for languageTag "ru". 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_python_scriptName_error_wrongName = () => "tab_config_python_scriptName_error_wrongName"


/**
 * Failed to resolve message tab_config_python_scriptName_error_wrongPath for languageTag "ru". 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tab_config_python_scriptName_error_wrongPath = () => "tab_config_python_scriptName_error_wrongPath"
